export const mapSite = (site) => {
    switch (site) {
        case 'finale_park':
            return 'Area Camper'
        case 'silos':
            return 'Area Silos'
        default:
            return site
    }
}